import { createGlobalStyle } from 'styled-components';

import colors from './variables/colors';
import metrics from './variables/metrics';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    text-transform: none !important;
  }

  html,
  body,
  #root {
    height: 100%;
    font-family: ${metrics.font.family};
    background: ${colors.bgColor};
    color: ${colors.text.primary};
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body,
  input,
  button,
  textarea,
  select {
    font: ${metrics.font.size.sm} ${metrics.font.family};
    color: ${colors.text.primary};
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${metrics.font.family};
    color: ${colors.text.primary};
    font-weight: ${metrics.font.weight.bold};
  }

  *:focus {
    outline: 0;
  }

  a {
    text-decoration: none;
    color: ${colors.primary.main};
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
  }

  /* MUI global — force font everywhere (portaled elements on body) */
  .MuiTypography-root,
  .MuiInputBase-root,
  .MuiInputLabel-root,
  .MuiMenuItem-root,
  .MuiButton-root,
  .MuiSelect-select,
  .MuiFormLabel-root {
    font-family: ${metrics.font.family} !important;
    text-transform: none !important;
  }

  .MuiInput-underline:after,
  .MuiFilledInput-underline:after {
    border-bottom-color: ${colors.primary.main} !important;
  }
  .MuiInputLabel-root.Mui-focused {
    color: ${colors.primary.main} !important;
  }

  /* MUI DatePicker calendar — app colors */
  .MuiPickersDay-root.Mui-selected {
    background-color: ${colors.primary.main} !important;
  }
  .MuiPickersDay-root:hover {
    background-color: rgba(2, 145, 239, 0.08) !important;
  }
  .MuiPickersCalendarHeader-root,
  .MuiDayCalendar-weekDayLabel,
  .MuiPickersDay-root,
  .MuiPickersYear-yearButton,
  .MuiPickersMonth-monthButton,
  .MuiDialogActions-root .MuiButton-root {
    font-family: ${metrics.font.family} !important;
    text-transform: none !important;
  }
  .MuiPickersYear-yearButton.Mui-selected,
  .MuiPickersMonth-monthButton.Mui-selected {
    background-color: ${colors.primary.main} !important;
  }
  .MuiDialogActions-root .MuiButton-root {
    color: ${colors.primary.main} !important;
  }

  /* MUI DataTable filter chip list */
  [class*="MUIDataTableFilterList-root"] {
    padding: 8px 14px !important;
  }

  /* MUI DataTable filter dialog (rendered as portal on body) */
  [class*="MUIDataTableFilter-root"] {
    font-family: ${metrics.font.family} !important;
    padding: 16px 24px !important;
  }
  [class*="MUIDataTableFilter-root"] * {
    font-family: ${metrics.font.family} !important;
    text-transform: none !important;
  }
  [class*="MUIDataTableFilter-root"] .MuiGrid-container {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 12px 20px !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  [class*="MUIDataTableFilter-root"] .MuiGrid-container > .MuiGrid-item {
    max-width: 100% !important;
    flex-basis: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  /* FE-08 — dar ekran düzeltmeleri.
     Bu bloklar global.js'te DURMAK ZORUNDA: MUI hem filtre diyaloğunu hem de
     seçim/menü katmanlarını body'ye portal olarak basar; hiçbir bileşen
     kapsamlı stil onlara ulaşamaz. */
  @media (max-width: 600px) {
    /* İki kolonluk filtre ızgarası 390px'te kolon başına ~170px demekti:
       etiketler kırpılıyor, tarih seçicileri taşıyordu. Tek kolon. */
    [class*="MUIDataTableFilter-root"] .MuiGrid-container {
      grid-template-columns: 1fr !important;
      gap: 10px 0 !important;
    }
    [class*="MUIDataTableFilter-root"] {
      padding: 12px 14px !important;
    }
    /* Filtre diyaloğu telefonda ekranı taşmamalı; kendi içinde kaysın. */
    [class*="MUIDataTableFilter-root"] {
      max-width: 100vw !important;
      max-height: 85vh !important;
      overflow-y: auto !important;
    }
    /* Uygulanan filtre afişi tek satırda kalıp yatay taşma yaratmasın. */
    [class*="MUIDataTableFilterList-root"] {
      flex-wrap: wrap !important;
      padding: 8px 10px !important;
    }
    /* Portal'lı MUI menü/seçim katmanları (satır ⋮ menüsü, kolon seçici)
       telefonda ekran dışına taşıyordu. */
    .MuiPopover-paper,
    .MuiMenu-paper {
      max-width: calc(100vw - 16px) !important;
    }
  }
`;
